import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { DatadogConfig } from './datadog_types';

let isRumInitialized = false;
let isLogsInitialized = false;

export function initDatadogRum(config: DatadogConfig) {
  if (!config.enabled || isRumInitialized) return;
  isRumInitialized = true;

  datadogRum.init({
    applicationId: config.applicationId,
    clientToken: config.clientToken,
    site: config.site,
    service: config.service,
    env: config.env,
    version: config.version,
    sessionSampleRate: config.sessionSampleRate,
    sessionReplaySampleRate: config.sessionReplaySampleRate,
    defaultPrivacyLevel: config.defaultPrivacyLevel as 'mask-user-input' | 'mask' | 'allow',
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    allowedTracingUrls: [{ match: /\/api\//, propagatorTypes: ['tracecontext', 'datadog'] }],
  });
}

export function initDatadogLogs(config: DatadogConfig) {
  if (!config.enabled || isLogsInitialized) return;
  isLogsInitialized = true;

  datadogLogs.init({
    clientToken: config.clientToken,
    site: config.site,
    service: config.service,
    env: config.env,
    version: config.version,
    forwardErrorsToLogs: config.forwardErrorsToLogs,
    forwardConsoleLogs: config.forwardConsoleLogs,
    sessionSampleRate: config.sessionSampleRate,
  });
}

export function initDatadog(config: DatadogConfig) {
  initDatadogRum(config);
  initDatadogLogs(config);
}

export function isDatadogRumInitialized() {
  return isRumInitialized;
}

export function resetDatadogRum() {
  isRumInitialized = false;
}

export function resetDatadogLogs() {
  isLogsInitialized = false;
}
